import axios from "axios";
import React, { forwardRef, useEffect, useState } from "react";
import Autocomplete from "../../../uiComponents/Autocomplete/Autocomplete";

const DoctorList = forwardRef(({selectedItemData, selectedDoctorId}, ref)  => {
    // state Management 
  const [doctorListData, setDoctorListData] = useState([]);
  const [loading, setLoading] = useState(false);
  

    const getDoctorListFromLocalStorage = () => {
        const doctorListLocal = localStorage.getItem("doctorList"); // get localStorage by serviceList key
        if (doctorListLocal) {
          // doctorList key exist
          setDoctorListData(JSON.parse(doctorListLocal)); // convert localStoreage  string value to object & update state
          // console.log("newDoctorList", JSON.parse(doctorListLocal));
        } else {
          // service list key dow not exist so run axios to get data from remote host
          getDoctorList();
        }
      };
      const getDoctorList  = () =>{
        setLoading(true);
        axios.get(`/dentrino-doctors-manager`)
        .then(response =>{
          setLoading(false);
          const doctorList = response.data;
          const newDoctorList = [];
          doctorList.map((item) => newDoctorList.push({value: item.id, label:item.doctor_name}))
          localStorage.setItem("doctorList", JSON.stringify(newDoctorList)); // stringify & set to local storage
          
          setDoctorListData(newDoctorList);
          
        })
        .catch(error =>{
          setLoading(false);
           console.error(error)
          })
        .finally(() => console.log)
      }

      useEffect(()=>{
        getDoctorListFromLocalStorage()
      },[])
      // const selectedItemData = (itemData)=>{
      //     console.log("data - ", itemData);
      // }
  return (
    <>
      {/* <Autocomplete
          getOptionLabel={(option) => option.label}

        disablePortal
        id="combo-box-demo"
        options={doctorListData}
        sx={{ maxWidth: 250 }}
        defaultValue={doctorListData[0]}
        renderInput={(params) => <TextField {...params} label="Movie" />}
      /> */}
      <Autocomplete selectedItemData={selectedItemData} selectedDoctorId={selectedDoctorId} ref={ref}></Autocomplete>
    </>
  );
});

export default DoctorList;
